import { IOnRoute } from '../crud/types';

/**
 * Represents a new subrecord to be sent to the backend.
 * Used as the data payload when uploading a subrecord.
 */
export interface INewSubrecord {
  subrecord_id: string; // Unique identifier for the subrecord
  record_id: string; // Source record ID
  user_text: string; // User entered text of the subrecord
  non_ai?: boolean; // If true, skips AI processing and excludes from chat context
  consolidateEntireChat?: string; // If true value, the backend will summarize the entire chat (record + subrecords), ignoring any current user text.
  replaceChatWithConsolidation?: boolean; // if true, the consolidated subrecord will replace the initial record (and then deleted ..)
  uploadedFiles?: string[]; // Array of file keys for uploaded files associated with this subrecord
}

/**
 * Represents a subrecord as stored in the Redux state.
 * Extends INewSubrecord to include execution timestamp and on-route status.
 */
export interface ISubrecord extends INewSubrecord, IOnRoute {
  ai_text: String; // AI generated text of the subrecord.
  interim?: boolean | undefined; // true when the backend sent an interim ai response.
  created_at: string; // Timestamp when the subrecord was saved.
  saas_tenant_id?: string;
  saas_tenant_name?: string;
  is_consolidated?: boolean; // true when the subrecord was consolidated from the record and previous subrecords.
}

// Subrecords CRUD params
export interface ICreateSubrecordParams extends INewSubrecord {}

export interface IReadSubrecordParams {
  record_id?: string;
}

// Subrecords-specific action types
export const ADD_SUBRECORD = 'ADD_SUBRECORD';
export const SET_SUBRECORDS = 'SET_SUBRECORDS';
export const SET_SUBRECORD_CONFIRMED_BY_BACKEND = 'SET_SUBRECORD_CONFIRMED_BY_BACKEND';
export const DELETE_SUBRECORD = 'DELETE_SUBRECORD';
export const CLEAR_SUBRECORDS = 'CLEAR_SUBRECORDS';

// Subrecords-specific action interfaces
export interface ISetSubrecordAction {
  type: typeof SET_SUBRECORDS;
  payload: {
    recordId: string;
    subrecords: ISubrecord[];
  };
}

export interface IAddSubrecordAction {
  type: typeof ADD_SUBRECORD;
  payload: ISubrecord;
}

export interface IDeleteSubrecordAction {
  type: typeof DELETE_SUBRECORD;
  payload: {
    recordId: string;
    subrecordId: string;
  };
}

export interface ISubrecordConfirmationData {
  user_text?: string;
  ai_text: string;
  interim?: boolean | undefined; // true when the backend sent an interim ai response
  is_consolidated?: boolean;
  saas_tenant_id: string;
  saas_tenant_name: string;
}

export interface ISetSubrecordConfirmedByBackendAction {
  type: typeof SET_SUBRECORD_CONFIRMED_BY_BACKEND;
  recordId: string;
  subrecordId: string;
  data: ISubrecordConfirmationData;
}

export interface IClearSubrecordAction {
  type: typeof CLEAR_SUBRECORDS;
}

export interface ISubrecordsState {
  subrecords: Record<string, ISubrecord[]>; // Group activities by recordId
}

// analyticsData: any[];
